import axios, { AxiosRequestConfig } from 'axios';
import ApiExecutor from '@dotmind/utils/dist/react/ApiExecutor';

import { TIMEOUT } from 'internal/constants/api';

if (!process.env.REACT_APP_API_URL || !process.env.REACT_APP_API_KEY)
  throw new Error('Need API_URL and API_KEY env vars');

// eslint-disable-next-line
export type RequestType = AxiosRequestConfig | Record<string, any>;

function apiInstance() {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: TIMEOUT,
    headers: {
      ['X-Veloclik-Apikey']: process.env.REACT_APP_API_KEY || '',
    },
  });
}

function api() {
  const instance = apiInstance();

  return {
    ...new ApiExecutor(instance),
    setAuthToken: (token: string) => (instance.defaults.headers.common['Authorization'] = token),
    removeAuthToken: () => {
      delete instance.defaults.headers.common['Authorization'];
    },
  };
}

export default api();
